module.exports = __webpack_public_path__ + "img/reporting_posts_content.edf37df5.svg";